// extracted by mini-css-extract-plugin
module.exports = {"betSlipHeader":"betslip-header_betSlipHeader___th4k","active":"betslip-header_active__qiuGa"};